"use client";
import Link from "next/link";
import Navbar from "../Navbar";
import styles from "@/app/styles/content.module.scss";
import contactData from "@/data/contact";
import { useRef, useState, useEffect } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Image from "next/image";

gsap.registerPlugin(ScrollTrigger);

function Section1({ onReady }) {
  const containerRef = useRef(null);
  const headerRef = useRef(null);
  const btnLeftRef = useRef(null);
  const btnRightRef = useRef(null);
  const clientRef = useRef(null);
  const [heroLoaded, setHeroLoaded] = useState(false);
  useEffect(() => {
    if (heroLoaded) onReady?.(); // ส่งสัญญาณขึ้นไปยัง Content
  }, [heroLoaded, onReady]);

  useGSAP(
    () => {
      if (!heroLoaded) return;
      gsap.fromTo(
        clientRef.current,
        { opacity: 0, x: 100 },
        {
          opacity: 1,
          x: 0,
          duration: 1,
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 60%",
            toggleActions: "play none none none",
          },
        }
      );
      gsap.fromTo(
        headerRef.current,
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 60%",
            toggleActions: "play none none none",
          },
        }
      );
      gsap.fromTo(
        btnRightRef.current,
        { opacity: 0, x: 100 },
        {
          opacity: 1,
          x: 0,
          duration: 0.7,
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 60%",
            toggleActions: "play none none none",
          },
        }
      );
      gsap.fromTo(
        btnLeftRef.current,
        { opacity: 0, x: -100 },
        {
          opacity: 1,
          x: 0,
          duration: 1,
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 60%",
            toggleActions: "play none none none",
          },
        }
      );
      gsap.fromTo(
        containerRef.current,
        { opacity: 0, y: "-50vh" },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 60%",
            toggleActions: "play none none none",
          },
        }
      );
    },
    { scope: containerRef, dependencies: [heroLoaded] }
  );

  useEffect(() => {
    if (!heroLoaded) {
      // ถ้ามี element image แล้วและ complete (กรณี cache) ให้ set true
      const el = headerRef.current | null;
      if (el && el.complete) setHeroLoaded(true);
    }
  }, [heroLoaded]);

  return (
    <>
      <Navbar
        color="#fff"
        filter={
          "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7452%) hue-rotate(235deg) brightness(111%) contrast(102%)"
        }
      />
      <section ref={containerRef} className={styles.section1}>
        {/* <div className={styles.videoBackground}>
          <video playsInline width="800" height="400" autoPlay muted loop>
            <source src={heroData[0].videoURL} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div> */}
        <div className={styles.imageBackground}>
          <Image
            src="/HeroSection/hero-background.jpg"
            alt="waterfall hero background image"
            width={1200}
            height={1080}
            quality={100}
            priority
            placeholder="blur"
            blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwMCIgaGVpZ2h0PSIxMDgwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciLz4="
            style={{ objectFit: "cover" }} // ป้องกันการบีบยืด
            onLoad={() => setHeroLoaded(true)}
          ></Image>
        </div>

        <div className={styles.dataWrapperSection1}>
          <div className={styles.hero}>
            {/* <h1 className="text-[48px] font-[700] p-[5vw] " ref={headerRef}>
              ให้สวนของคุณ <br /> &quot;อบอุ่น&quot; กว่าที่เคย
            </h1>
            <p>{heroData[0].description}</p> */}
            <Image
              src="/HeroSection/inspired.svg"
              width={500}
              height={500}
              alt="waterfall hero background image"
              quality={100}
              priority
              ref={headerRef}
            ></Image>
            <p>ให้สวนของคุณ “อบอุ่น” กว่าที่เคย</p>
            <div className={styles.btn}>
              {/* <Link
                href="/projects"
                className={styles.explore_btn}
                ref={btnLeftRef}
              >
                ชมผลงานของเรา
              </Link> */}
              <Link
                href={`https://line.me/R/ti/p/${contactData.lineID}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.contact_btn}
                ref={btnRightRef}
              >
                ปรึกษาทีมงาน
              </Link>
            </div>
          </div>
          {/* <div className={`${styles.clients} font-lora`} ref={clientRef}>
            <h2>{heroData[0].clients}</h2>
            <p>Social Media Followers</p>
            <div className={styles.circleGroup}>
              <div className={styles.circle}></div>
              <div className={styles.circle}></div>
              <div className={styles.circle}></div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Section1;
